<template>
  <div class="terms-container">
    <div class="logo-container d-flex justify-end">
      <router-link to="/">
        <img
          src="../assets/images/logo/good_casper_black.svg"
          alt="Good Casper logo"
          width="280"
        />
      </router-link>
    </div>
    
    <h1>Terms and Conditions</h1>
    
    <p class="section-title">Introduction</p>
    <p>
      These Terms and Conditions ("Agreement") are a legally binding agreement
      between you and Good Casper. ("Good Casper," "we," "us," or "our")
      governing your access and use of the Good Casper mobile application (the
      "App") and our website (the "Site"). By using the App or Site, you agree
      to be bound by this Agreement. If you do not agree to these terms and
      conditions, please do not use the App or Site.
    </p>

    <p class="section-title">User Conduct</p>
    <p>
      1.1 You are solely responsible for all activities and content that you
      post, upload, share or otherwise transmit through the App or Site.
    </p>
    <p>1.2 You agree not to use the App or Site to:</p>
    <ul>
      <li>
        (a) upload or share any content that is unlawful, harmful, threatening,
        abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of
        another's privacy, hateful, or racially, ethnically or otherwise
        objectionable;
      </li>
      <li>
        (b) impersonate any person or entity or falsely state or otherwise
        misrepresent your affiliation with a person or entity;
      </li>
      <li>
        (c) forge headers or otherwise manipulate identifiers in order to
        disguise the origin of any content transmitted through the App or Site;
      </li>
      <li>
        (d) upload or share any content that you do not have a right to make
        available under any law or under contractual or fiduciary relationships;
      </li>
      <li>
        (e) upload or share any content that infringes any patent, trademark,
        trade secret, copyright or other proprietary rights of any party;
      </li>
      <li>
        (f) upload or share any unsolicited or unauthorized advertising,
        promotional materials, "junk mail," "spam," "chain letters," "pyramid
        schemes," or any other form of solicitation;
      </li>
      <li>
        (g) upload or share any content that contains software viruses or any
        other computer code, files or programs designed to interrupt, destroy or
        limit the functionality of any computer software or hardware or
        telecommunications equipment; or
      </li>
      <li>
        (h) interfere with or disrupt the App or Site or servers or networks
        connected to the App or Site.
      </li>
    </ul>

    <p class="section-title">User Content</p>
    <p>
      2.1 By uploading, sharing or otherwise transmitting any content through
      the App or Site, you grant Good Casper a non-exclusive, transferable,
      sub-licensable, royalty-free, worldwide license to use, reproduce, modify,
      publish, distribute, and display such content for the purpose of providing
      the App and Site services to you.
    </p>
    <p>
      2.2 You represent and warrant that you have all necessary rights to
      upload, share or otherwise transmit the content and that such content does
      not infringe any third party's proprietary rights, privacy rights or
      publicity rights.
    </p>

    <p class="section-title">Ownership and Intellectual Property Rights</p>
    <p>
      3.1 Good Casper owns all rights, title, and interest in and to the App and
      Site, including without limitation all intellectual property rights.
    </p>
    <p>
      3.2 You may not copy, modify, distribute, sell, or lease any part of the
      App or Site or included software, nor may you reverse engineer or attempt
      to extract the source code of that software, unless laws prohibit those
      restrictions or you have Good Casper's written permission.
    </p>

    <p class="section-title">Personal Information and Privacy</p>
    <p>
      4.1 Good Casper may collect, use, store, and disclose your personal
      information in accordance with our Privacy Policy. By using the App or
      Site, you consent to our collection, use, storage, and disclosure of your
      personal information in accordance with our Privacy Policy.
    </p>
    <p>
      4.2 You are responsible for maintaining the confidentiality of your login
      information and for all activities that occur under your account. Good
      Casper will not be liable for any loss or damage arising from your failure
      to comply with this Section.
    </p>

    <p class="section-title">Termination</p>
    <p>
      5.1 Good Casper may terminate your access to the App or Site at any time,
      without notice, for any reason, including but not limited to a breach of
      this Agreement.
    </p>

    <p class="section-title">Privacy</p>
    <p class="font-weight-bold">User Data</p>
    <p>
      6.1 By using the Good Casper App, you acknowledge and agree that Good
      Casper may collect, store, and process personal information about you and
      the deceased person or pet for the purposes outlined in our Privacy
      Policy.
    </p>
    <p>
      6.2 You understand and consent to the collection of data, including but
      not limited to, profile information, images, videos, documents, and any
      other content you upload or share on the App.
    </p>

    <p class="section-title">Privacy Settings</p>
    <p>
      7.1 Good Casper provides privacy settings that allow you to control the
      visibility of the information you share. It is your responsibility to
      manage these settings and understand how your content is displayed on the
      App.
    </p>

    <p class="section-title">Third-Party Services</p>
    <p>
      8.1 Good Casper may utilize third-party services for analytics,
      advertising, or other purposes. These third-party services may collect and
      use information in accordance with their own privacy policies. Good Casper
      is not responsible for the privacy practices of these third-party
      services.
    </p>

    <p class="section-title">Security</p>
    <p>
      9.1 Good Casper employs reasonable security measures to protect the
      confidentiality and integrity of your data. However, you acknowledge that
      no method of transmission over the internet or electronic storage is
      completely secure, and Good Casper cannot guarantee absolute security.
    </p>

    <p class="section-title">Cookies and Tracking Technologies</p>
    <p>
      10.1 The App and Site may use cookies and other tracking technologies to
      enhance user experience. You can manage cookie preferences through your
      browser settings.
    </p>

    <p class="section-title">Communication</p>
    <p>
      11.1 By using the App, you consent to receive communications from Good
      Casper, including emails, messages, and push notifications. You can
      opt-out of certain communications through your account settings.
    </p>

    <p class="section-title">Changes to Privacy Policy</p>
    <p>
      12.1 Good Casper reserves the right to update and change the Privacy
      Policy. You are encouraged to review the Privacy Policy regularly to stay
      informed about how your information is collected, used, and protected.
    </p>

    <p class="section-title">User Responsibility</p>
    <p>
      13.1 You are solely responsible for the accuracy, legality, and
      appropriateness of the content you upload or share on the App, including
      personal information about the deceased person or pet.
    </p>

    <p class="section-title">Contact Information</p>
    <p>
      14.1 If you have any questions or concerns about the privacy practices,
      please contact us at <a href="mailto:contact@goodcasper.com">contact@goodcasper.com</a>
    </p>

    <p class="section-title">Agreement</p>
    <p class="font-weight-bold">
      By using the Good Casper App, you affirm that you have read, understood,
      and agreed to the Privacy Policy, as well as these Terms and Conditions.
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = "Good Casper - Terms and Conditions";
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
};
</script>

<style lang="scss" scoped>
.terms-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background: #fff;
  min-height: 100vh;
  font-family: 'Montserrat', sans-serif;

  .logo-container {
    margin-bottom: 3rem;
    
    img {
      transition: transform 0.3s ease;
      &:hover {
        transform: scale(1.02);
      }
    }
  }

  h1 {
    font-size: 2.5rem;
    font-weight: 700;
    color: #333;
    margin-bottom: 2rem;
    text-align: center;
  }

  .section-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #333;
    margin: 2.5rem 0 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #f0f0f0;
  }

  p {
    font-size: 1rem;
    line-height: 1.6;
    color: #444;
    margin-bottom: 1rem;
    text-align: justify;

    &.font-weight-bold {
      font-weight: 600;
      color: #333;
      font-size: 1.1rem;
      margin-top: 2rem;
    }
  }

  ul {
    list-style-type: none;
    padding-left: 1.5rem;
    margin: 1rem 0;

    li {
      position: relative;
      padding-left: 1.5rem;
      margin-bottom: 0.75rem;
      line-height: 1.6;
      color: #444;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: #666;
        font-weight: bold;
      }
    }
  }

  a {
    color: #4ECDC4;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #FF6B6B;
    }
  }

  @media (max-width: 768px) {
    padding: 1.5rem;

    h1 {
      font-size: 2rem;
    }

    .section-title {
      font-size: 1.3rem;
    }

    p {
      font-size: 0.95rem;
    }

    ul {
      padding-left: 1rem;
    }
  }
}
</style>